import { makeAutoObservable } from "mobx"
import { arrayRemoveDuplicates } from "react-sdk/utils"

export class Ftue {
  id
  PopupID
  surtitle
  title
  image
  Text

  constructor(json) {
    Object.assign(this, json)
    makeAutoObservable(this)
  }
}


class Ftues {
  all = []
  viewed_types = [];

  init(json) {
    this.all = json
    .filter(elem => elem.id).map(elem => new Ftue(elem))
  }

  get ids() { return this.all.map(c => c.id)}

  get ftueIds () {
    return arrayRemoveDuplicates(this.all.map(s => s.PopupID))
  }
  get(type) { return this.all.filter(ftue => ftue.PopupID === type) }

  hasBeenViewed(type) {
    return this.viewed_types.includes(type);
  }

  addViewed(type) {
    if (!this.hasBeenViewed(type))
      this.viewed_types.push(type)
  }
  stateToJson() {
    return this.viewed_types;
  }
  stateFromJson(data) {
    if (data) {
      this.viewed_types = data;
    }
  }

}


export default new Ftues()